import { saveUserDataToLocalStorage } from '@/services/localStorage-users-data';


export default {
  mobileMenuOpen(state: any, payload: boolean) {
    state.mobile.menuOpen = payload;
  },
  mobileMenuGroupingOpen(state: any, payload: boolean) {
    state.mobile.menuGroupingOpen = payload;
  },
  mobileMenuGroupingTop(state: any, payload: number) {
    state.mobile.menuGroupingTop = payload;
  },
  mobileMenuReportTabsOpen(state: any, payload: boolean) {
    state.mobile.menuReportTabsOpen = payload;
  },
  mobileMenuReportTabsTop(state: any, payload: number) {
    state.mobile.menuReportTabsTop = payload;
  },
  mobileDesktopViewForced(state: any, payload: any) {
    state.mobile.desktopViewForced = payload;
    saveUserDataToLocalStorage(state.user?.id,{desktopViewForced:payload});
  },
  mobileDesktopViewForcedCurrent(state: any, payload: any) {
    state.mobile.desktopViewForcedCurrent = payload;
  },
};
